import { render } from "./MainId.vue?vue&type=template&id=0283581a&scoped=true"
import script from "./MainId.vue?vue&type=script&lang=js"
export * from "./MainId.vue?vue&type=script&lang=js"

import "./MainId.vue?vue&type=style&index=0&id=0283581a&scoped=true&lang=css"

import exportComponent from "/builds/engineering/loans-and-lines/commercial-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0283581a"]])

export default __exports__